<template>
  <a-config-provider :locale="locale" >
    <router-view></router-view>
  </a-config-provider>
</template>

<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

  export default {
    name: 'App',
    components: {
    },
    data() {
      return {
        locale: zhCN,
      }
    }
  }
</script>

<style lang="less">
    @import "assets/css/common";
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*text-align: center;*/
        color: #2c3e50;
    }
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    .container {
        background-color: #ffffff;
        min-height: calc(100vh - 214px);
    }

    .flex {
        display: flex;
        justify-content: space-between;
        .flex-sm {
            width: 240px !important;
        }
    }

    /*列表公共样式*/
    .pc-wrapper {
        width: 1200px;
        margin: 23px auto;

        .breadcrumb-custom {
            margin: 0 28px 40px;
        }

        .search-content {
          margin: 0 28px;
          .search-row {
            margin-bottom: 24px;
            display: flex;
            flex-flow: row;
            .search-col {
              display: flex;
              align-items: center;
              .search-tit {
                font-size: 16px;
                font-weight: 600;
                color: #000000d9;
                flex: 0 0 auto;
              }
              .search-type-list {
                display: flex;
                flex-flow: row wrap;

                .first-item {
                  padding: 5px 12px;
                  margin: 0 6px;
                  color: #000000d9;
                  font-size: 16px;
                  border-radius: 3px;
                  cursor: pointer;
                  &.active {
                    color: #ffffff;
                    background: rgba(255, 105, 55, 1);
                  }
                  &.active-arrow {
                    position: relative;

                    &::after {
                      content: '';
                      position: absolute;
                      bottom: -22px;
                      left: 20px;
                      width: 14px;
                      height: 14px;
                      background-size: 100% auto;
                      background-repeat: no-repeat;
                      background-image: url("/src/assets/images/search-triangle02@2x.png");
                      z-index: 20;
                    }
                  }
                }

                .second-list {
                  position: absolute;
                  top: 48px;
                  background-color: #ffffff;
                  border: 1px solid #d8d8d8;
                  padding: 10px;
                  width: 1092px;
                  display: flex;
                  flex-flow: row wrap;

                  .second-item {
                    padding: 4px 8px;
                    color: #000000d9;
                    font-size: 16px;
                    cursor: pointer;
                    &.active {
                      color:  rgba(255, 105, 55, 1);
                    }
                  }
                }

                /deep/.flex {
                  display: flex;
                }
              }
              .search-input /deep/,
              .search-select /deep/ {
                width: 358px;
                height: 40px;
                .ant-input,
                .ant-select-selection--single,
                .ant-select-selection__rendered {
                  height: 40px !important;
                  line-height: 40px !important;
                }
              }
            }
            .search-col + .search-col {
              margin-left: 55px;
            }
            .btn-search /deep/ {
              margin-left: 18px;
              .ant-btn {
                width: 85px;
                height: 40px;
                color: #ffffff;
                border-color: #f18532;
                background: linear-gradient(116.6deg, #ff6937 0%, #f18532 100%);
                font-size: 16px;
                padding-top: 3px;
              }
            }
          }
        }
    }

    /deep/ .ant-btn {
      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0);
      box-shadow: 0 2px 0 rgba(0, 0, 0, 0);
    }
    .ant-pagination /deep/ {
      .ant-pagination-prev:focus,
      .ant-pagination-prev:hover,
      .ant-pagination-next:focus,
      .ant-pagination-next:hover,
      .ant-pagination-item:focus,
      .ant-pagination-item:hover {
        border-color: #F0233D;
        > a {
          color: #F0233D;
          border-color: #F0233D;
        }
      }
      .ant-pagination-item-active {
        border-color: #d9d9d9;
        > a {
          color: #F0233D;
        }
      }
      .ant-pagination-item-active:focus,
      .ant-pagination-item-active:hover {
        border-color: #F0233D;
        > a {
          color: #F0233D;
        }
      }
    }
</style>
